import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import { withRouter } from "react-router-dom";
import MUIStack from "@mui/material/Stack";
import MUITooltip from "@mui/material/Tooltip";
import MUITypography from "@mui/material/Typography";
import MainContext from "../../../../Context/MainContext/MainContext";
import Format from "../../../../Utility/Format";
import User from "../../../../Utility/Crud/User";

export default withRouter(
  class CardAdminUserList extends CardClass {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders the content of the card.
     * @returns {JSX.Element} The users table.
     */
    renderContent() {
      const users = User.sort(
        this.context.allUsers.filter((user) => {
          return (
            user.role !== "THIRD_PARTY_USER" &&
            (this.props.showInactive || user.active === true)
          );
        }),
      );

      const {
        userprofileRolesIndexed,
        userprofileLocationsIndexed,
        rolesIndexed,
        locationsIndexed,
      } = this.context;

      const rolesByUser = new Map();
      const locationsByUser = new Map();

      for (const assignment of Object.values(userprofileRolesIndexed)) {
        if (
          assignment.deleted === true ||
          !(assignment.roleId in rolesIndexed)
        ) {
          continue;
        }

        const names = rolesByUser.get(assignment.userProfileId) ?? [];
        names.push(rolesIndexed[assignment.roleId].name);
        rolesByUser.set(assignment.userProfileId, names);
      }

      for (const assignment of Object.values(userprofileLocationsIndexed)) {
        const names = locationsByUser.get(assignment.userprofileId) ?? [];
        names.push(locationsIndexed[assignment.locationsId].name);
        locationsByUser.set(assignment.userprofileId, names);
      }

      const rows = users.map((user) => {
        const roles = (rolesByUser.get(user.id) ?? []).sort();
        const locations = (locationsByUser.get(user.id) ?? []).sort();

        return {
          id: user.id,
          user: {
            searchValue: [User.getDisplayName(user), ...roles].join(" "),
            content: (
              <MUIStack spacing={0.25}>
                <MUITypography variant="body2">
                  {User.getDisplayName(user)}
                </MUITypography>
                {roles.length > 0 ? (
                  <MUITypography variant="caption" color="text.secondary">
                    {roles.join(", ")}
                  </MUITypography>
                ) : null}
              </MUIStack>
            ),
          },
          locations: {
            searchValue: locations.join(", "),
            content: (
              <MUIStack spacing={0.25}>
                <MUITypography variant="body2">
                  {locations.slice(0, 5).join(", ")}
                </MUITypography>
                {locations.length > 5 ? (
                  <MUITooltip title={locations.join(", ")}>
                    <MUITypography
                      component="span"
                      variant="caption"
                      color="text.secondary"
                      sx={{ cursor: "default" }}
                    >
                      + {locations.length - 5} more
                    </MUITypography>
                  </MUITooltip>
                ) : null}
              </MUIStack>
            ),
          },
          contact: {
            searchValue: [user.email, user.fax, Format.phone(user.fax)].join(
              " ",
            ),
            content: (
              <MUIStack spacing={0.25}>
                <MUITypography variant="body2">{user.email}</MUITypography>
                {user.fax ? (
                  <MUITypography variant="caption" color="text.secondary">
                    Fax: {Format.phone(user.fax)}
                  </MUITypography>
                ) : null}
              </MUIStack>
            ),
          },
        };
      });

      return (
        <Table
          search={true}
          columns={[
            { key: "id", name: "ID", type: "number" },
            { key: "user", name: "User", type: "custom" },
            { key: "contact", name: "Contact", type: "custom" },
            {
              key: "locations",
              name: "Location(s)",
              type: "custom",
              width: "40%",
            },
          ]}
          rows={rows}
          onClick={(user) => {
            this.props.history.push({
              pathname: "/admin/user/" + user.id,
            });
          }}
        />
      );
    }
  },
);
